import { render, staticRenderFns } from "./CPULogo.vue?vue&type=template&id=d36d1dd2&functional=true&"
import script from "./CPULogo.vue?vue&type=script&lang=js&"
export * from "./CPULogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports